import { createSlice } from "@reduxjs/toolkit";
import { fetchAllSecurityGroups, fetchPermissions, getAllGeoLocations, getAllRelationshipTypesApi, getUOMByType, removeRelationshipTypesApi } from "../api/common";

interface CommonState {
  loading: boolean;
  currentRequestId: undefined | string;
  userData: any;
  error: any;
  geoLocation: any;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  userData: null,
  error: null,
  geoLocation:null,
} as CommonState;
 export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers:{
        resetCommon: () => initialState,
      },
    extraReducers(builder) {

      builder

        .addCase("RESET_ALL", (state, action) => {
          return initialState;
        })
        .addCase(fetchAllSecurityGroups.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(fetchAllSecurityGroups.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(fetchAllSecurityGroups.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
          .addCase(fetchPermissions.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(fetchPermissions.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(fetchPermissions.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
          .addCase(getAllRelationshipTypesApi.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(getAllRelationshipTypesApi.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(getAllRelationshipTypesApi.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
          .addCase(removeRelationshipTypesApi.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(removeRelationshipTypesApi.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(removeRelationshipTypesApi.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
          .addCase(getAllGeoLocations.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(getAllGeoLocations.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              if(action.payload.status === 200 || action.payload.status === 201) {
                let stateArray: any = [];
                let cityArray: any = [];
                action?.payload?.data?.forEach((element: any) => {
                  stateArray.push(element?.stateName);
                  cityArray.push(element?.districts);
                });
                state.geoLocation = {
                  states: stateArray,  
                  cities: cityArray,
                }
              }
            }
          })
          .addCase(getAllGeoLocations.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
          .addCase(getUOMByType.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(getUOMByType.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(getUOMByType.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
    }
 })

 export const { resetCommon } = commonSlice.actions;

export default commonSlice.reducer;
